export enum CDNProviders {
  UNPKG = 'UNPKG',
  JSDELIVR = 'JSDELIVR',
}
